import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { Phone, Mail, Instagram, MapPin } from 'lucide-react';
import { CONTACT, NAV_ITEMS } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-black border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 py-12 sm:py-14 grid grid-cols-1 md:grid-cols-4 gap-8 sm:gap-10">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-5 text-zinc-400 text-sm max-w-md leading-relaxed">
            Expert marine equipment manufacturing. From design to build we account for everything a marine contractor would need to because we actually use the equipment we build. No compromises. No shortcuts. Built to work. Engineered to last.
          </p>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.24em] text-zinc-500 mb-4">Navigate</div>
          <ul className="space-y-2">
            {NAV_ITEMS.map((n) => (
              <li key={n.label}>
                <a href={n.href} className="text-zinc-300 hover:text-cyan-300 transition-colors text-sm">{n.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.24em] text-zinc-500 mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-cyan-300" /> {CONTACT.salesPhone.number}</li>
            <li>
              <a
                href={`mailto:${CONTACT.email}`}
                className="flex items-center gap-2 hover:text-cyan-300 transition-colors break-all"
              >
                <Mail className="w-4 h-4 text-cyan-300 shrink-0" /> {CONTACT.email}
              </a>
            </li>
            <li>
              <a
                href={CONTACT.instagramUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 hover:text-cyan-300 transition-colors"
              >
                <Instagram className="w-4 h-4 text-cyan-300" /> {CONTACT.instagram}
              </a>
            </li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-cyan-300" /> Fort Myers, FL</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 py-6">
          <p className="text-[11px] leading-relaxed text-zinc-600 max-w-5xl" data-testid="footer-disclaimer">
            Group Absolute Builders LLC d/b/a Absolute Marine Equipment is a fully licensed and bonded marine contractor. We are not consultants, advisors, engineers, or attorneys, and nothing on this site — including specifications, pricing, performance descriptions, reviews, and project imagery — constitutes professional, legal, engineering, or financial advice, or should be construed as anything other than general product information. Product specifications, pricing, and availability are subject to change without notice and are confirmed only in a written quote. All text, imagery, video, and design on this site are the exclusive intellectual property of Group Absolute Builders LLC and may not be copied, reproduced, or repurposed without prior written permission.
          </p>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 py-4 sm:py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-zinc-500">© {new Date().getFullYear()} Group Absolute Builders LLC d/b/a Absolute Marine Equipment. All rights reserved.</div>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <Link
              to="/privacy"
              className="text-xs text-zinc-500 hover:text-cyan-300 transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <Link
              to="/sms-terms"
              className="text-xs text-zinc-500 hover:text-cyan-300 transition-colors"
              data-testid="footer-sms-terms-link"
            >
              SMS Terms
            </Link>
            <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-600">Built for Work · Engineered to Last</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
